module.exports = __webpack_public_path__ + "static/media/19ю10.978b4686.webp";